/**
 * Рассчитывает ширину элемента ввода на основе длины его значения и максимальной допустимой длины.
 * @param {number} length - Длина значения ввода.
 * @param {number | string} max - Максимально допустимая длина значения ввода.
 * @returns {string} Значение ширины элемента ввода в единицах ch.
 */

const getWidthForInput = (length, max) => {
  if (length === 0) {
    return '1ch';
  }
  const maxValue = max + 1;
  return `${length < maxValue ? length + 0.7 : maxValue}ch`;
};
export default getWidthForInput;
